export enum AgoraVirtualBackgroundEffect {
    blur = "blur",
    img = "img",
    color = "color"
}